/**
 * The connection, as a piece of React state.
 *
 * Kept apart from net.js so that module stays importable from anywhere — the service worker
 * helpers and the plain library modules have no business importing React.
 */
import { useEffect, useState } from 'react';
import { isOnline, onNetChange } from './net';

export function useOnline() {
  const [online, setOnline] = useState(isOnline);
  useEffect(() => {
    setOnline(isOnline());           // in case it changed between render and effect
    return onNetChange(setOnline);
  }, []);
  return online;
}

export default useOnline;
